module.exports = __webpack_public_path__ + "static/ff-saleslanding-icon-disease.bce8f80f.png";